@if (finishedLoading) {
    <div class="container-fluid pt-3">
        <ngx-masonry [options]="{ percentPosition: true, gutter: 10 }">
            @if (permService.permissions.HasRiskExportAccess) {
                <div ngxMasonryItem class="masonry-item">
                    <export-risks></export-risks>
                </div>
            }
            @if (permService.permissions.HasEventExportAccess) {
                <div ngxMasonryItem class="masonry-item">
                    <export-events></export-events>
                </div>
            }
            @if (permService.permissions.HasKriExportAccess) {
                <div ngxMasonryItem class="masonry-item">
                    <export-kri></export-kri>
                </div>
            }
            @if (permService.permissions.HasAdvancedTestingExportAccess) {
                <div ngxMasonryItem class="masonry-item">
                    <export-controls></export-controls>
                </div>
            }
            @if (permService.permissions.HasImprovementManagementExportAccess) {
                <div ngxMasonryItem class="masonry-item">
                    <export-bim></export-bim>
                </div>
            }
            @if (permService.permissions.HasDataManagementExportAccess) {
                <div ngxMasonryItem class="masonry-item">
                    <export-datamanagement></export-datamanagement>
                </div>
            }
            @if (permService.permissions.HasUsersImportExportAccess) {
                <div ngxMasonryItem class="masonry-item">
                    <export-users></export-users>
                </div>
            }
            @if (permService.permissions.HasTaskAccess) {
                <div ngxMasonryItem class="masonry-item">
                    <export-tasks></export-tasks>
                </div>
            }
            @if (hasIncidentAccess) {
                <div ngxMasonryItem class="masonry-item">
                    <export-incidents></export-incidents>
                </div>
            }
        </ngx-masonry>
    </div>
} @else {
    <cerrix-loader [showLoader]="true"></cerrix-loader>
}
